(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9379],{

/***/ 19379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52257);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(145);
/* harmony import */ var ab_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(276);
/* harmony import */ var _hero_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62061);
/* harmony import */ var _hero_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_hero_scss__WEBPACK_IMPORTED_MODULE_6__);







var Hero = function(param) {
    var title = param.title, titulo = param.titulo, subtitle = param.subtitle, subTitulo = param.subTitulo, image = param.image, imageMobile = param.imageMobile, imagemobile = param.imagemobile, video = param.video, videoMobile = param.videoMobile, i18n = param.i18n;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isIOS = ref[0], setIOS = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isHome = ref1[0], setIsHome = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), videoWebEl = ref2[0], setvideoWeb = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), volumeWeb = ref3[0], setvolumeWeb = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), videoMobileEl = ref4[0], setvideoMobile = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), volumeMobile = ref5[0], setvolumeMobile = ref5[1];
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    // console.log("language", title, t("404-title"));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var _videoWebEl = document.getElementsByTagName("video")[0];
        var _videoMobileEl = document.getElementsByTagName("video")[1];
        setvideoWeb(_videoWebEl);
        setvideoMobile(_videoMobileEl);
        if (_videoWebEl) {
            _videoWebEl.volume = 0;
            setvolumeWeb(0);
        }
        if (_videoMobileEl) {
            _videoMobileEl.volume = 0;
            _videoMobileEl.muted = true;
            setvolumeMobile(0);
        }
    }, [
        video,
        videoMobile
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        setIOS([
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod", 
        ].includes(navigator.platform) || // iPad on iOS 13 detection
        ((navigator.userAgent.includes("Mac") || navigator.userAgent.includes("iPhone")) && "ontouchend" in document));
        if (i18n.language == "es" && ((ref1 = (ref = window.location.pathname) === null || ref === void 0 ? void 0 : ref.split("/")) === null || ref1 === void 0 ? void 0 : ref1.length) > 2 || i18n.language == "en" && !((ref2 = window.location.pathname) === null || ref2 === void 0 ? void 0 : ref2.includes("en/home")) || i18n.language == "de" && !((ref3 = window.location.pathname) === null || ref3 === void 0 ? void 0 : ref3.includes("de/start"))) {
            setIsHome(false);
        }
    }, []);
    // console.log("ab-hero", t("rooms"), t("huespedes"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "hero".concat(title == "404" ? " not-found" : ""),
        children: [
            video || videoMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        className: "image web",
                        src: video.mediaItemUrl || video,
                        id: "video",
                        loop: true,
                        autoPlay: true,
                        playsInline: true,
                        preload: "auto",
                        poster: image === null || image === void 0 ? void 0 : image.mediaItemUrl,
                        style: {
                            transform: "translate(0px, 0px)"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        className: "image mobile",
                        src: (videoMobile === null || videoMobile === void 0 ? void 0 : videoMobile.mediaItemUrl) || video,
                        loop: true,
                        id: "video-mobile",
                        muted: isIOS ? true : false,
                        autoPlay: true,
                        playsInline: true,
                        preload: "auto",
                        poster: image === null || image === void 0 ? void 0 : image.mediaItemUrl,
                        style: {
                            transform: "translate(0px, 0px)"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "volume-web",
                        style: {
                            bottom: isHome ? 120 : 40
                        },
                        onClick: function() {
                            if (videoWebEl) {
                                if ((videoWebEl === null || videoWebEl === void 0 ? void 0 : videoWebEl.volume) > 0) {
                                    setvolumeWeb(0);
                                    videoWebEl.volume = 0;
                                } else {
                                    setvolumeWeb(1);
                                    videoWebEl.volume = 1;
                                }
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: (videoWebEl === null || videoWebEl === void 0 ? void 0 : videoWebEl.volume) > 0 ? "/images/volumen-on.svg" : "/images/volumen-off.svg",
                            height: 36,
                            width: 36,
                            alt: "volumen"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "volume-mobile",
                        style: {
                            bottom: isHome ? 120 : 30
                        },
                        onClick: function() {
                            // let videomobile = document.getElementsByTagName("video")[1];
                            if (videoMobileEl) {
                                if (!(videoMobileEl === null || videoMobileEl === void 0 ? void 0 : videoMobileEl.muted)) {
                                    setvolumeMobile(0);
                                    videoMobileEl.volume = 0;
                                    videoMobileEl.muted = true;
                                } else {
                                    setvolumeMobile(1);
                                    videoMobileEl.muted = false;
                                    videoMobileEl.volume = 1;
                                }
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: (videoMobileEl === null || videoMobileEl === void 0 ? void 0 : videoMobileEl.muted) ? "/images/volumen-off.svg" : "/images/volumen-on.svg",
                            height: 26,
                            width: 26,
                            alt: "volumen"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: (image === null || image === void 0 ? void 0 : image.mediaItemUrl) || image || "/images/404.png",
                        layout: "fill",
                        objectFit: "cover",
                        style: {
                            opacity: 0.6,
                            zIndex: -1
                        },
                        id: "hero-desktop",
                        alt: "portada"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: imageMobile || (imagemobile === null || imagemobile === void 0 ? void 0 : imagemobile.mediaItemUrl) || (image === null || image === void 0 ? void 0 : image.mediaItemUrl) || "/images/404.png",
                        objectFit: "cover",
                        layout: "fill",
                        style: {
                            opacity: 0.6,
                            zIndex: -1
                        },
                        id: "hero-mobile",
                        alt: "portada"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                element: "h2",
                className: "hero-text",
                children: title || titulo
            }),
            title == "404" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        element: "h2",
                        children: t("404-title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: t("404-text")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        prefetch: false,
                        text: t("404-volver"),
                        href: t("/")
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                element: "span",
                className: "title",
                children: subtitle || subTitulo
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero);


/***/ }),

/***/ 62061:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);